// Utility to handle scroll-based UI updates
export function initScrollHandlers() {
    if (typeof window === 'undefined') return;

    const backToTopButton = document.getElementById('back-to-top');

    if (!backToTopButton) return;

    // Show/hide button based on scroll position
    const handleScroll = () => {
        if (window.scrollY > 300) {
            backToTopButton.classList.add('visible');
        } else {
            backToTopButton.classList.remove('visible');
        }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    // Cleanup function
    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
}
